export default {
    ':root': [
        {
            title: '获取Header名称',
            type: 'text',
            value: {
                get: function (_a) {
                    var data = _a.data;
                    return data.headerName;
                },
                set: function (_a, value) {
                    var data = _a.data;
                    data.headerName = value;
                }
            }
        },
    ]
};
